import React from 'react'
import ReactDOM from 'react-dom/client'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'

import './index.css'
import { App } from './App'
import { SettingsPage } from './pages/SettingsPage/SettingsPage'
import { NotFoundPage } from './pages/NotFoundPage/NotFoundPage'
import { InfoPage } from './pages/InfoPage.tsx/InfoPage'
import { PasihyppelyPage } from './pages/Pasihyppely/PasihyppelyPage'
import { SotilasarvotPage } from './pages/Sotilasarvot/SotilasarvotPage'
import routes, { RoutePath } from './routes'
import { Analytics } from './components/Analytics'
import { CookieConsent } from './components/CookieConsent/CookieConsent'

const getElement = (path: RoutePath): JSX.Element => {
  switch (path) {
    case '/':
      return <App />
    case '/asetukset':
      return <SettingsPage />
    case '/info':
      return <InfoPage />
    case '/pasihyppely':
      return <PasihyppelyPage />
    case '/sotilasarvot':
      return <SotilasarvotPage />
    default:
      return <NotFoundPage />
  }
}

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Failed to find the root element')
}
const root = ReactDOM.createRoot(rootElement)

root.render(
  <React.StrictMode>
    <Router>
      <Analytics />
      <Routes>
        {routes.map((path: RoutePath) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const element = getElement(path)
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          return <Route key={path} path={path} element={element} />
        })}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <CookieConsent />
    </Router>
  </React.StrictMode>
)
